import React, { useMemo } from 'react';
import { useFetchGet } from '../../utils/fetch/useFetchGet';
import { paths, pathsApi } from '../../router/paths';
import i18n from '../../utils/i18n';
import Body from '../../ui/Body/body';
import GridCol from '../../ui/GridCol';
import ButtonLink from '../../ui/Button/buttonLink';
import { ButtonVariationEnum } from '../../ui/Button/types';
import GridRow from '../../ui/GridRow';
import Table from '../../ui/Table';
import { TagEnum } from '../../ui/Tag/types';
import { boolToReadable } from '../../utils/boolUtil';
import Tag from '../../ui/Tag';
import { ICategoryShort } from '../../utils/types';
import SortRootCategories from './modules/sortRootCategories';

const CategoryAll = () => {
    const { data, setData } = useFetchGet<Array<ICategoryShort>>({ path: pathsApi.categoryAll });

    const sortedCategories = useMemo(() => {
        if (!data?.length) {
            return [];
        }

        const [rootCategories, ...rest] = data
            .reduce<Array<Array<ICategoryShort>>>((acc, category) => {
                if (acc[category.depth]) {
                    acc[category.depth].push(category);
                } else {
                    acc[category.depth] = [category];
                }
                return acc;
            }, [])
            .map((item) => item.sort((a, b) => a.order - b.order));
        rest.forEach((categories) => {
            categories.reverse().forEach((category) => {
                const parentIndex = rootCategories.findIndex((item) => item.id === category.parentId);
                rootCategories.splice(parentIndex + 1, 0, category);
            });
        });

        return rootCategories;
    }, [data]);

    return (
        <Body title={i18n.menu.category} isLoading={!data}>
            <GridRow gutter={8}>
                <GridCol col={12}>
                    <GridRow isFlex gutter={8}>
                        <ButtonLink href={paths.categoryNew} variation={ButtonVariationEnum.SOFT}>
                            {i18n.menu.categoryNew}
                        </ButtonLink>
                        <SortRootCategories categories={sortedCategories} setCategoryCallback={setData} />
                    </GridRow>
                </GridCol>
                <GridCol col={12}>
                    <Table
                        widths={[40, 10]}
                        headers={[i18n.general.category, i18n.general.active]}
                        data={sortedCategories?.map((item) => ({
                            items: [
                                ' - '.repeat(item.depth) + item.name,
                                <Tag type={!!item.deletedAt ? TagEnum.RED : TagEnum.GREEN}>
                                    {boolToReadable(!item.deletedAt)}
                                </Tag>,
                            ],
                            id: item.id,
                            link: paths.category + item.id,
                        }))}
                    />
                </GridCol>
            </GridRow>
        </Body>
    );
};

export default CategoryAll;
